// Mapping keyed by the normalized English name used in world-atlas (lowercase,
// no accents, no whitespace). Each value lists alternative names that may come
// from the API (catalan, spanish, portuguese, etc.) plus the ISO 3166-1 alpha-2
// country code, so a `country` field that stores ISO codes (es, de, fr…) — as
// Sherpa's bp_singlefile does — also matches the map. Add more as needed.
export const COUNTRY_ALIASES = {
  spain: ['espanya', 'españa', 'espagne', 'spagna', 'es'],
  france: ['frança', 'francia', 'fr'],
  portugal: ['portugal', 'pt'],
  poland: ['polonia', 'polònia', 'pologne', 'pl'],
  italy: ['italia', 'itàlia', 'it'],
  germany: ['alemanya', 'alemania', 'allemagne', 'deutschland', 'de'],
  'unitedkingdom': ['regneunit', 'reinounido', 'royaumeuni', 'uk', 'gb', 'greatbritain'],
  netherlands: ['paisosbaixos', 'paisesbajos', 'holanda', 'paysbas', 'nl'],
  belgium: ['belgica', 'bèlgica', 'belgique', 'be'],
  switzerland: ['suissa', 'suiza', 'suisse', 'schweiz', 'ch'],
  austria: ['austria', 'àustria', 'autriche', 'at'],
  greece: ['grecia', 'grècia', 'gr'],
  ireland: ['irlanda', 'ie'],
  denmark: ['dinamarca', 'dk'],
  sweden: ['suecia', 'suècia', 'se'],
  norway: ['noruega', 'no'],
  finland: ['finlandia', 'finlàndia', 'fi'],
  'czechia': ['republicacheca', 'czechrepublic', 'chequia', 'cz'],
  hungary: ['hongria', 'hungria', 'hu'],
  romania: ['romania', 'romanía', 'ro'],
  bulgaria: ['bulgaria', 'bulgària', 'bg'],
  croatia: ['croacia', 'croàcia', 'hr'],
  slovenia: ['eslovenia', 'eslovènia', 'si'],
  slovakia: ['eslovaquia', 'eslovàquia', 'sk'],
  ukraine: ['ucraina', 'ucrania', 'ua'],
  turkey: ['turquia', 'turquía', 'tr'],
  morocco: ['marroc', 'marruecos', 'ma'],
  algeria: ['algeria', 'argelia', 'dz'],
  tunisia: ['tunisia', 'tunez', 'tn'],
  egypt: ['egipte', 'egipto', 'eg'],
  'unitedstatesofamerica': ['eua', 'estadosunidos', 'usa', 'us', 'unitedstates', 'estatsunits'],
  mexico: ['mexic', 'méxico', 'mx'],
  brazil: ['brasil', 'br'],
  argentina: ['argentina', 'ar'],
  chile: ['xile', 'cl'],
  colombia: ['colombia', 'co'],
  china: ['xina', 'cn'],
  japan: ['japo', 'japón', 'jp'],
  india: ['india', 'índia', 'in'],
  russia: ['russia', 'rússia', 'ru'],
  canada: ['canada', 'canadà', 'ca']
};
